import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const AIRBNB_URL = "https://www.airbnb.co.uk/rooms/1613755826986177504";
export const CONTACT_EMAIL = "gus@micklefields.co.uk";
export const MANOR_NAME = "The Magicians' House";
export const MANOR_LOCATION = "Stoke Ferry, West Norfolk";
